// IMPORT
    // MODULE(S)
        import React from 'react';
    // STYLE(S)
        import '../sass/Footer.scss';



// MAIN CONTENT - FUNCTION / COMPONENT
    function Footer() {


        // RETURN
            return (
                <div className="footer App-section none">
                    <h5>Made with</h5>
                    <p><a href="https://reactjs.org/" target="_blank" rel="noopener noreferrer">React</a></p>
                </div>
            )
    }
    export default Footer;



// EXTRA
    // REACT ICON
    /*
        <div className="footer App-section">
            <p className="react"><a href="https://reactjs.org/" target="_blank" rel="noopener noreferrer">React</a></p>
        </div>
    */
